import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TreeNode } from '@cdw-ae/common-ui-components-tree';
import { firstValueFrom } from 'rxjs';
import { OrgUnitsDataService } from '../access-management/org-units/org-units-data.service';
import { AdministrationComponent } from '../administration.component';
// import { DeviceCacheComponent } from './device-cache/device-cache.component';
import { GopherBuddySetupComponent } from './gopher-buddy-setup/gopher-buddy-setup.component';
// import { LicensingContactsComponent } from './licensing-contacts/licensing-contacts.component';
import { TimeZoneDateFormatComponent } from './time-zone-date-format/time-zone-date-format.component';

@Component({
  selector: 'global-settings',
  standalone: true,
  imports: [
    CommonModule,
    AdministrationComponent,
    MatTabsModule,
    GopherBuddySetupComponent,
    // DeviceCacheComponent,
    TimeZoneDateFormatComponent,
    // LicensingContactsComponent,
  ],
  templateUrl: './global-settings.component.html',
  styleUrl: './global-settings.component.scss',
})
export class GlobalSettingsComponent implements OnInit {
  public selectedIndex = 0;
  public ouTreeData: TreeNode[] = [];

  constructor(private orgUnitsDataService: OrgUnitsDataService) {}

  async ngOnInit(): Promise<void> {
    // Fetch OU tree data from API
    this.ouTreeData = await firstValueFrom(
      this.orgUnitsDataService.getOrgUnits()
    );
  }

  public onMainTabChange(tabIndex: number): void {
    this.selectedIndex = tabIndex;
  }
}
